import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
// avoid multiple data loading
let dataLoading = false;

export default {
	created() {
		// do not load data more than once in this mixin
		if (!this.dataAvailable && !dataLoading) {
			dataLoading = true;

			Promise.all([
				this.$store.dispatch('staticData/fetchMenus'),
				this.$store.dispatch('staticData/fetchLang'),
				this.$store.dispatch('staticData/fetchLanguageList'),
				this.$store.dispatch('staticData/fetchCategories'),
				this.$store.dispatch('staticData/fetchBackgrounds'),
				this.$store.dispatch('staticData/fetchGeneralSettings'),
			]).then(() => {
				// update the footerMenu in the other module
				this.$store.commit(
					'contentData/updateData',
					{ target: 'footerMenu', newValue: this.allMenus.find(e => e.id === Number(this.generalSettings.footer)).childrenArray },
				);
				// data fetch complete
				this.$store.commit('staticData/updateDataStatus', true);
			}).finally(() => { dataLoading = false; });
		}
	},
	methods: {
		...mapActions('staticData',	[
			'fetchMenus',
			'fetchLang',
			'fetchLanguageList',
		]),
		...mapMutations('staticData', [
			'updateLanguage',
		]),
	},
	computed: {
		...mapState('staticData', {
			dataAvailable: 'dataAvailable',
			storagePath: 'storagePath',
			staticBackgrounds: 'backgrounds',
			generalSettings: 'generalSettings',
		}),
		...mapGetters('staticData', {
			allMenus: 'getAllMenus',
			language: 'getLanguage',
			languageList: 'getLanguageList',
			categories: 'getCategories',
		}),
		logoSrc() {
			const src = `${this.storagePath}logo${this.$store.state.CID}.png`;
			return src;
		},
		logoSrcS() {
			return (skipCIDCheck) => {
				if (!skipCIDCheck) {
					if (this.$store.state.CID === 2) return this.logoSrc;
					if (this.$store.state.CID === 3) return this.logoSrc;
				}
				const src = `${this.storagePath}logo${this.$store.state.CID}s.png`;
				return src;
			};
		},
		logoSrcSSvg() {
			return (icon) => {
				const src = `${this.storagePath}${icon}.svg`;
				return src;
			};
		},
		iconSrc() {
			const src = `${this.storagePath}favicon${this.$store.state.CID}.png`;
			return src;
		},
	},
};
